var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.57672 8.71173C8.20505 8.71173 9.52611 7.38099 9.52611 5.74087C9.52611 4.10071 8.20505 2.77002 6.57672 2.77002C4.94839 2.77002 3.62731 4.10071 3.62731 5.74087C3.62731 7.38099 4.94839 8.71173 6.57672 8.71173ZM9.19845 9.37193H8.06985C7.61518 9.58233 7.10925 9.70199 6.57672 9.70199C6.04419 9.70199 5.54033 9.58233 5.08358 9.37193H3.95501C2.50693 9.37193 1.33331 10.5541 1.33331 12.0127V12.3427C1.33331 12.8895 1.77368 13.3331 2.31645 13.3331H10.837C11.3798 13.3331 11.8201 12.8895 11.8201 12.3427V12.0127C11.8201 10.5541 10.6465 9.37193 9.19845 9.37193Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4458 4.64707L14.5638 3.52096C14.701 3.38277 14.701 3.15872 14.5638 3.02042L14.3154 2.77014C14.1782 2.63196 13.9557 2.63196 13.8184 2.77014L12.7004 3.89626L11.5824 2.77014C11.4452 2.63196 11.2228 2.63196 11.0855 2.77014L10.837 3.02042C10.6998 3.15861 10.6998 3.38266 10.837 3.52096L11.955 4.64707L10.837 5.77318C10.6998 5.91137 10.6998 6.13542 10.837 6.27372L11.0855 6.52399C11.2227 6.66218 11.4452 6.66218 11.5824 6.52399L12.7004 5.39788L13.8184 6.52399C13.9556 6.66218 14.1782 6.66218 14.3154 6.52399L14.5638 6.27372C14.701 6.13553 14.701 5.91148 14.5638 5.77318L13.4458 4.64707Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersCancel);
export default __webpack_public_path__ + "static/media/users-cancel.e6a102e1a9fbfce63557db793e8e793c.svg";
export { ForwardRef as ReactComponent };